























































































































































































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Input from '../../core/components/Input.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import VehiclesActions from './VehiclesActions.vue'
import { CompanyListItem, CompanyDetail, postCompanyResponse, postNewCompany, patchCompany, patchCompanyResponse } from '../models/Companies';
import { CompaniesService } from '../api/CompaniesService';
import { msgLimitValidation, phoneValidator, rutValidation, formRules } from '../../core/utils/validations';
import { ID } from '../../core/utils';
import { User } from '../../user/models/Users';
import UserList from '../../user/components/UserList.vue';
import CompanyVehiclesList from './CompanyVehiclesList.vue';
import CompanyModules from './CompanyModules.vue';
import { Vehicle } from '../../core/models/Vehicle';
@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        VehiclesActions,
        Input,
        UserList,
        CompanyVehiclesList,
        CompanyModules,
        InfoIcon,
    }
})
export default class ModalAddCompany extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: null}) patchData: CompanyDetail | null;
    usersList: Array<User> = [];
    vehiclesList: Array<Vehicle> = [];
    modalTitle: string = 'Crear Empresa';
    modalWidth: number = 500;
    name: string = '';
    address: string = '';
    rut: string = '';
    debt: boolean = false;
    tyc: boolean = false;
    submitName: string = 'Guardar';
    totalMsgLimit: string | number | null = 0;
    currentMsgLimit: number | string = '-';
    drivingPeriod: string = '';
    drivingPeriodTooltip: string = 'Periodicidad de datos enviados por los vehículos en estado de conducción';
    errorMsg: string = '';
    rutValidator: Function = rutValidation;
    drivingPeriodRules: Function = v => !!v || 'El campo no puede estar vacío';
    msgLimitValidator: Function = msgLimitValidation;
    hideDetailsMsgLimit: boolean = false;

    @Emit()
    updateInsuranceKey(value){}

    @Emit()
    removeInsuranceService(){}

    setErrorForm(text) {
        this.errorMsg = text;
    }

    loadPatchData(){
        if(this.patchData !== null){
            this.modalTitle = 'Modificar Empresa: <b>' + this.patchData.name + '</b>';
            this.submitName = 'Modificar Empresa'
            this.modalWidth = 1024;
            this.updateName(this.patchData.name);
            this.updateAddress(this.patchData.address);
            this.updateRut(this.patchData.rut);
            this.updateDrivingPeriod(this.patchData.driving_period);
            this.updateDebt(this.patchData.debt);
            this.updateTyc(this.patchData.has_to_accept_tyc);
            this.updateTotalMsgLimit(this.patchData.message_limit.total);
            this.updateCurrentMsgLimit(this.patchData.message_limit.actual_month);
            this.setUsersList(this.patchData.users)
            this.setVehiclesList(this.patchData.vehicles)

        }
    }

    get isPatch(){
        return this.patchData !== null ? true : false
    }

    get formIsValid() {
        this.hideDetailsMsgLimit = true;
        this.setErrorForm('');
        if(this.name === ''){
            this.setErrorForm('No ingresó el nombre')
            return false
        }

        if(this.totalMsgLimit === '' || this.totalMsgLimit == null){
            this.setErrorForm('No ingresó el límite de mensajes')
            this.hideDetailsMsgLimit = false;
            return false
        }
        if(this.totalMsgLimit !== '' && this.totalMsgLimit !== null){
            this.setErrorForm('');
            if(msgLimitValidation(this.totalMsgLimit) !== true){
                this.hideDetailsMsgLimit = false;
                this.setErrorForm('El límite de mensajes es muy alto')
                return false
            }
        }
        if(this.rut !== '' || this.rut !== null){
            this.setErrorForm('No ingresó el RUT')
            if(rutValidation(this.rut) !== true){
                this.setErrorForm('El RUT no es válido')
                return false
            }
        }

        if(this.isPatch && this.drivingPeriod === '' || this.drivingPeriod == null){
            this.setErrorForm('No ingresó el período de reporte')
            return false
        }
        
        return true
    }


    getData(){
        return {
            name: this.name,
            address: this.address,
            rut: this.rut,
            debt: this.debt,
            has_to_accept_tyc: this.tyc,
            message_limit: this.totalMsgLimit,
            driving_period: Number(this.drivingPeriod)
        }
    }

    submitAction() {
       let dataToSubmit = this.getData();
       if(this.patchData == null){
        this.postCompany(dataToSubmit);
       }else{
        this.patchCompany(dataToSubmit, this.patchData.id)
       }
    }
    handleSuccessAction(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    postCompany(data){
        this.$_showLoadingDialog('Creando Empresa');
        CompaniesService.postCompany(
            data
        ).then((res: postCompanyResponse) => {
            this.handleSuccessAction(res, 'Empresa creada con éxito');
            let companyToAdd: CompanyListItem = {
                ...data,
                id: res.company.id,
                vehicles: 0,
                users:0,
                recipients: 0,
                is_insurance: false,
                modules: {
                    journeys: false,
                    peritaje: false
                }
            }
            this.addNewCompany(companyToAdd);
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo crear la Empresa');
        })
    }

    patchCompany(data, companyId: ID){
        this.$_showLoadingDialog('Modificando Empresa');
        CompaniesService.patchCompany(
            data, companyId
        ).then((res: patchCompanyResponse) => {
            this.handleSuccessAction(res, 'Empresa actualizada con éxito');
            this.updateCompany(res.company);
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo modificar la Empresa');
        })
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewCompany(item: CompanyListItem) {}

    @Emit()
    updateCompany(item: CompanyListItem) {}

    updateName(value){
        this.name = value;
    }
    updateAddress(value){
        this.address = value;
    }
    updateRut(value){
        this.rut = value;
    }
    updateDrivingPeriod(value){
        this.drivingPeriod = value;
    }
    updateDebt(value){
        this.debt = value;
    }
    updateTyc(value){
        this.tyc = value;
    }
    updateTotalMsgLimit(value){
        this.totalMsgLimit = value;
    }
    updateCurrentMsgLimit(value){
        this.currentMsgLimit = value;
    }

    setUsersList(items: Array<User>){
        this.usersList = items;
    }
    setVehiclesList(items: Array<Vehicle>){
        this.vehiclesList = items;
    }

    mounted() {
        this.$nextTick(() => {
            this.loadPatchData();
        });
    }
}
